$(document).ready(function () {
  if ($(".ajax-filter-form").length > 0) {
    var form = $(".ajax-filter-form");
    var url = form.data("url");

    form.find("input").change(function (e) {
      e.preventDefault();
      var data = form.serialize();
      callAjax(url, data);
    });

    $(document).on("click", ".loadmore__button", function (e) {
      console.log("load more");
      e.preventDefault();
      var lengthInput = $("input[name='Length']");
      $("input[name='Length']").val(parseFloat(lengthInput.val()) + 6);

      var data = form.serialize();
      callAjax(url, data);
    });

    function callAjax(url, data) {
      $.ajax({
        type: "GET",
        url: url,
        data: form.serialize(),
        success: function (response) {
          $(".blog-entries-wrapper").html(response);
          var newUrl = $(".blog-entries__all").data("url");
          history.pushState(null, null, newUrl);
        },
      });
    }
  }
});
